<template>
  <div class="box1 d-pad-30">
    <ValidationObserver
      v-slot="{ invalid }"
      tag="form"
      class="form-large"
      @submit.prevent="submit"
    >
      <slot :formData="formData" />
    </ValidationObserver>
  </div>
</template>

<script>
import usesValidation from '@/mixins/veeValidate'
export default {
  name: 'DSForm',

  mixins: [usesValidation],

  props: {
    prefillFormData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      formData: {},
      invalid: false,
    }
  },

  watch: {
    prefillFormData: {
      immediate: true,
      handler(formData) {
        this.setData(formData)
      },
    },
  },

  mounted() {
    if (this.prefillFormData) {
      this.setData(this.prefillFormData)
    }
  },

  methods: {
    setData(formData) {
      this.formData = formData
    },
    submit() {
      this.$emit('submit', this.formData)
    },
  },

}
</script>

<style lang="css" scoped>

>>> fieldset .field.left {
  margin-right: 4%;
}

>>> fieldset .field.full-width {
  margin-right: 0;
  width: 100%;
}

button + button {
  margin-left: 0.25em;
}

</style>
